import React from "react";

export default function LoadingScreen() {
    return (
        <div
            data-testid="loading-screen"
            className="min-h-screen flex items-center justify-center"
        >
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gobbyblue" />
        </div>
    );
}
